// 公共的请求方法
import axios from '../utlis/request'
let API = '';
// let API = 'http://shulianyun.baiyishequ.com';

const api = {
  // 登录接口
  postAccountLogin(paramsJson) {
    var params = new URLSearchParams();
    for (var key in paramsJson) {
      params.append(key, paramsJson[key])
    }
    return axios.post(API + '/api/user/userAuth.api.php?act=accountLogin', params)
  },
  // 字典
  getLoginPage() {
    return axios.get(API + '/api/user/userAuth.api.php?act=loginPage', {
      params: {
      }
    })
  },

}


export default api;
